export enum StatusSolicitationWork {
    'Novo' = 1,
    'Em andamento' = 2,
    'Encaminhado' = 3,
    'Parado' = 4,
    'Pausado' = 5,
    'Cancelado' = 6,
    'Concluído' = 7,
    'Encerrada' = 8,
    'Reaberto' = 9,
    'Em planejamento' = 10,
    'Esperando solicitante' = 11,
    'Esperando atendente' = 12,
    'Esperando outra área' = 13,
    'Em aprovação' = 14,
}

export enum StatusSolicitationWorkPortugues {
    'Novo' = 1,
    'Em andamento' = 2,
    'Encaminhado' = 3,
    'Parado' = 4,
    'Pausado' = 5,
    'Cancelado' = 6,
    'Concluído' = 7,
    'Encerrada' = 8,
    'Reaberto' = 9,
    'Em planejamento' = 10,
    'Esperando solicitante' = 11,
    'Esperando atendente' = 12,
    'Esperando outra área' = 13,
    'Em aprovação' = 14,
}

export enum SolicitationUrgency {
    'Normal' = 1, 'Média' = 2, 'Alto' = 3, 'Crítico' = 4
}

export enum ProcessType {
    'Incidente' = 1, 'Requisição' = 2, 'Demanda' = 3, 'Mudança' = 4, 'Consultoria' = 5, 'Rotina' = 6, 'Relacionamento' = 7, 'Projeto' = 8, 'Problema' = 9, 'Ativação' = 10
}

export enum SolicitationUrgencyPortugues {
    "Normal" = 1, "Média" = 2, "Alta" = 3, "Crítica" = 4
}

export enum LastComment {
    'Sem Comentário' = 0, 'Solicitante' = 1, 'attendante' = 2
}

interface SolicitationNames {
    statusDescription: string;
    urgencyDescription: string;
    businessAreaName: string;
    customerName: string;
    serviceGroupName: string;
    serviceName: string;
    processName: string;
}

export interface Solicitation extends SolicitationNames {
    id: number;
    disabled: boolean;
    idCompany: number;
    idBusinessUnit: number;
    idCustomer: number;
    nameCustomer: number;
    idStatus: StatusSolicitationWork;
    solicitationDate: Date;
    registrationDate: Date | string | null;
    subject: string;
    idOpenMode: number;
    idClassification: number | null;
    idBusinessArea: number;
    nameBusinessArea: string;
    idServiceGroup: number;
    nameServiceGroup: number;
    idService: number;
    nameService: number;
    idCmdb: number | null;
    serviceUrgency: SolicitationUrgency;
    cmdbUrgency: SolicitationUrgency;
    requesterUrgency: SolicitationUrgency;
    urgency: SolicitationUrgency;
    idPauseReason: number | null;
    endDate: Date | string | null;
    registrationEndDate: Date | string | null;
    closingDate: Date | string | null;
    idTypeSolution: number | null;
    idCause: number | null;
    idExpiryReason: number | null;
    reopening: number;
    automaticClosing: boolean;
    totalCost: number;
    cancellationDate: Date | string | null;
    idCancellationReason: number | null;
    suggestedDate: Date | string | null;
    idProcess: number | null;
    nameProcess: string | null;
    responseDate: Date | string | null;
    responseTime: number;
    workedTime: number;
    extraWorkedTime: number;
    pauseTime: number;
    totalTime: number;
    closedPackage: boolean;
    idUserRequester: number;
    nameUserRequester: number;
    idUserOpening: number;
    nameUserOpening: number;
    idUserClosing: number | null;
    nameUserClosing: number | null;
    idUserCancellation: number | null;
    nameUserCancellation: number | null;
    idFeature: number | null;
    closedTime: number;
    closedValue: number;
    idReopeningReason: number | null;
    idBillingType: number | null;
    idReasonNoCharge: number | null;
    hourValue: number | null;
    paymentAttendantDate: Date | string | null;
    billingReleasedDate: Date | string | null;
    idContract: number | null;
    ratReceived: boolean;
    userAditional: string;
    phoneAditional: string;
    emailAditional: string;
    idBillingRule: number | null;
    lastComment: LastComment;
    solicitationValue: number;
    totalWorkedTime: number;
    franchiseTime: number;
    noFranchiseTime: number;
    franchiseValue: number;
    noFranchiseValue: number;
    bhoTime: number | null;
    bhoBillingTime: number | null;
    bhoBillingAmount: number | null;
    idFranchiseType: number | null;
    idPlaceService: number | null;
    idGroupedRat: number | null;
    productName: string;
    productVersion: string;
    operationalSystem: string;

    idSharepoint: number | null;
    idResponsibleUser: number | null;
    supportOrder: number;
    extraResponseTime: number;
    idCalendar: number | null;
    bhoValue: number;
    generatedRevenue: number;
    generatedTime: number;
    finalValue: number;
    finalTime: number;
    belongsProject: number;
    searchClosedFranchise: number;
    idLinkedSolicitation: number | null;
    idFormSatisfactionSurvey: number | null;
    satisfactionSurveyRespond: boolean;
    idSolicitationGroup: number | null;
}
